import { memo } from 'react';
import { MButton } from '@Components/Base';
import { Form } from 'antd';

import styles from './footer-buttons.module.css';

interface CreateButtonsProps {
  disabledSaveForm: boolean;
  disabledSubmitForm: boolean;
  onSaveAsDraft: () => void;
}

const CreateButtons: React.FC<CreateButtonsProps> = ({
  disabledSaveForm,
  disabledSubmitForm,
  onSaveAsDraft,
}) => {
  return (
    <>
      <Form.Item>
        <MButton
          type="secondary"
          onClick={onSaveAsDraft}
          disabled={disabledSaveForm}
          className={styles.saveAsDraftButton}
        >
          Save As Draft
        </MButton>
      </Form.Item>
      <Form.Item>
        <MButton
          className={styles.submitButton}
          type="primary"
          htmlType="submit"
          disabled={disabledSaveForm || disabledSubmitForm}
        >
          Submit
        </MButton>
      </Form.Item>
    </>
  );
};

export default memo(CreateButtons);
